// react documenation used: https://react.dev/learn
// ReactRouter documentation used : https://reactrouter.com/web/guides/quick-start
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./components/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/pages/loginPage/loginPage";
import SignUp from "./components/pages/signUpPage/signUpPage";
import Home from "./components/pages/homePage/homePage";
import Account from "./components/pages/accountPage/accountPage";
import Search from "./components/pages/searchPage/searchPage";
import Discover from "./components/pages/discoverPage/discoverPage";
import Favourites from "./components/pages/favouritesPage/favouritesPage";
import CategoryPage from "./components/pages/categoryPage/categoryPage";
import "./App.css";

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/loginPage" element={<Login />} />
            <Route path="/signUpPage" element={<SignUp />} />
            <Route
              path="/homePage"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/accountPage"
              element={
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              }
            />
            <Route
              path="/searchPage"
              element={
                <ProtectedRoute>
                  <Search />
                </ProtectedRoute>
              }
            />
            <Route
              path="/discoverPage"
              element={
                <ProtectedRoute>
                  <Discover />
                </ProtectedRoute>
              }
            />
            <Route
              path="/favouritespage"
              element={
                <ProtectedRoute>
                  <Favourites />
                </ProtectedRoute>
              }
            />

            <Route
              path="/categories/:categoryName"
              element={
                <ProtectedRoute>
                  <CategoryPage />
                </ProtectedRoute>
              }
            />

            {/* takes user to login page when trying to access other pages without being authenticated*/}
            <Route path="*" element={<Navigate replace to="/loginPage" />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
